import React, { FC } from 'react';
import * as S from './FloatingBadges.style';
import whatsappIcon from 'Assets/whatsapp.svg';

interface Props {
  whatsAppPhone: string;
  whatsAppMessage?: string;
}

export const FloatingBadges: FC<Props> = ({
  whatsAppPhone,
  whatsAppMessage = '',
}) => {
  const cleanPhone = whatsAppPhone.replace(/\D/g, '');
  const waHref = `https://wa.me/${cleanPhone}${
    whatsAppMessage ? `?text=${encodeURIComponent(whatsAppMessage)}` : ''
  }`;

  return (
    <S.Stack data-testid="floating-badges">
      <S.Badge
        as="a"
        href={waHref}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp öffnen"
        title="WhatsApp"
        data-testid="floating-whatsapp"
        $primary
      >
        <S.WhatsAppImg src={whatsappIcon} alt="" />
        <S.BadgeTooltip>WhatsApp</S.BadgeTooltip>
      </S.Badge>
    </S.Stack>
  );
};

export default FloatingBadges;
